var map = {
	"./1/symbol_0.png": 83124,
	"./1/symbol_1.png": 4253,
	"./1/symbol_10.png": 23177,
	"./1/symbol_11.png": 98976,
	"./1/symbol_12.png": 96539,
	"./1/symbol_2.png": 20486,
	"./1/symbol_3.png": 5583,
	"./1/symbol_4.png": 93360,
	"./1/symbol_5.png": 25465,
	"./1/symbol_6.png": 11458,
	"./1/symbol_7.png": 75115,
	"./1/symbol_8.png": 78460,
	"./1/symbol_9.png": 12325,
	"./2/symbol_0.png": 92065,
	"./2/symbol_1.png": 70936,
	"./2/symbol_10.png": 45450,
	"./2/symbol_11.png": 96211,
	"./2/symbol_12.png": 21720,
	"./2/symbol_2.png": 66547,
	"./2/symbol_3.png": 34634,
	"./2/symbol_4.png": 5061,
	"./2/symbol_5.png": 69148,
	"./2/symbol_6.png": 76727,
	"./2/symbol_7.png": 93582,
	"./2/symbol_8.png": 66617,
	"./2/symbol_9.png": 60368,
	"./3/symbol_0.png": 22302,
	"./3/symbol_1.png": 74791,
	"./3/symbol_10.png": 51559,
	"./3/symbol_12.png": 597,
	"./3/symbol_2.png": 72140,
	"./3/symbol_3.png": 8053,
	"./3/symbol_4.png": 84282,
	"./3/symbol_5.png": 32035,
	"./3/symbol_6.png": 95176,
	"./3/symbol_7.png": 89041,
	"./3/symbol_8.png": 28086,
	"./3/symbol_9.png": 25023,
	"./4/symbol_0.png": 18123,
	"./4/symbol_1.png": 54466,
	"./4/symbol_10.png": 67352,
	"./4/symbol_12.png": 47402,
	"./4/symbol_2.png": 68473,
	"./4/symbol_3.png": 36368,
	"./4/symbol_4.png": 48591,
	"./4/symbol_5.png": 63494,
	"./4/symbol_6.png": 47261,
	"./4/symbol_7.png": 26132,
	"./4/symbol_8.png": 21427,
	"./4/symbol_9.png": 70666,
	"./gold1.png": 3130,
	"./gold2.png": 24241,
	"./gold3.png": 14024,
	"./gold4.png": 93639,
	"./silver1.png": 65989,
	"./silver2.png": 95630,
	"./silver3.png": 41207,
	"./silver4.png": 92216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7398;